// import React from "react";
// import TTSEventBody from "./TableBody/TTSEventBody";
// import TTSEventHead from "./TableHead/TTSEventHead";

// const TTSEventTable = ({
//   permissionsAccessControl,
//   ttsEvents,
//   handleOpenPopup,
//   handleDelete,
//   status,
// }) => {
//   return (
//     <div className="row" style={{ marginTop: "10px" }}>
//       <div className="col-12">
//         <div className="card">
//           <div className="card__body">
//             <div className="table-wrapper">
//               <table style={{ overflow: "hidden" }}>
//                 <TTSEventHead
//                   permissionsAccessControl={permissionsAccessControl}
//                   status={status}
//                 />
//                 <TTSEventBody
//                   ttsEvents={ttsEvents}
//                   handleOpenPopup={handleOpenPopup}
//                   handleDelete={handleDelete}
//                   status={status}
//                 />
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

import ReusableDataTable from "src/components/table/ReusableDataTable";
import { mapEventToDataTable as mapData } from "./Helper";
import GetTTSEventColumns from "./ColumnDefinition/TTSEventColumn/GetTTSEventColumns";

const TTSEventTable = ({ data, handleDelete, handleOpenPopup, status }) => {
  const columns = GetTTSEventColumns({
    handleDelete,
    handleOpenPopup,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={450} />
  );
};

export default TTSEventTable;
